export default __webpack_public_path__ + "static/media/AVATAR-04.44183483.png";